import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import './Toggle.scss'

const Toggle = ({ label = '', value, onUpdate, isDisabled, sliderWrapperClassName, sliderLabelClassName }) => {
    const { t } = useTranslation()
    const onChange = () => {
        if (isDisabled) return
        onUpdate(!value)
    }

    return (
        <div className={classNames('common-toggle', { 'common-toggle--is-disabled': isDisabled })}>
            <div
                className={classNames('common-toggle__slider-wrapper', {
                    'common-toggle__slider-wrapper--is-unchecked': !value,
                    [sliderWrapperClassName]: !!sliderWrapperClassName,
                })}
            >
                <span
                    className={classNames('common-toggle__slider', { checked: value })}
                    onClick={onChange}
                    title={value ? t('Disable') : t('Enable ')}
                />
            </div>
            {!!label && (
                <p
                    className={classNames('common-toggle__label', { [sliderLabelClassName]: !!sliderLabelClassName })}
                    onClick={onChange}
                >
                    {label}
                </p>
            )}
        </div>
    )
}

export default Toggle
